<ng-container *ngIf="matches?.length > 0">
  <lib-section-header
    *ngIf="title && titleIcon"
    [title]="title"
    [titleIcon]="titleIcon"
    [titleSize]="titleSize"
    [colorScheme]="colorScheme">
  </lib-section-header>
  <lib-slider [colorScheme]="colorScheme"
              [moreButtonTitle]="moreButtonTitle"
              [moreButtonRouterLink]="moreButtonRouterLink"
              [moreButtonLink]="moreButtonLink"
              [moreButtonSmall]="isMinimalLayout">
    <lib-slider-item *ngFor="let event of matches; let i = index" class="slider-item rise-on-hover">
      <lib-match-card
        [path]="itemLinkPath"
        [live]="isFootball && live"
        [match]="event"
        [layout]="cardLayout"
        [colorScheme]="colorScheme"
        [lazyLoadImage]="i > 3"
        [showContent]="false"
        [sportType]="sportType"
      ></lib-match-card>
    </lib-slider-item>
  </lib-slider>
</ng-container>

